export default theme => {
    return {}
}



// WEBPACK FOOTER //
// ./src/app/configuration/TmobileBussiness/theme/components/scorecard/MetricsLabels/index.js